
/* injects from baggage-loader */

'use strict';

export default class DialogFeedbackController {
    constructor($log, $state, $sce, Session) {
        'ngInject';
        this.$log = $log;
        this.$state = $state;
        this.$sce = $sce;
        this.Session = Session;
    }
    $onInit(){
        if(this.resolve.level<3)
            this.boxSize = 'smallBox';
        else
            this.boxSize = 'largeBox';
        this.remainingLevels = 3 - this.resolve.level;
        if(this.remainingLevels===1)
            this.remainingLevels+=" nível";
        else
            this.remainingLevels+=" níveis";

        this.timer = this.resolve.level ? this.Session.get().stages[this.resolve.stage].times : null;

        switch(this.resolve.stage){
            case 0:
            this.colorKey = 'red';
            this.keyName = 'Chave da Sabedoria';
            break;
            case 1:
            this.colorKey = 'blue';
            this.keyName = 'Chave da Imaginação';
            break;
            case 2:
            this.colorKey = 'yellow';
            this.keyName = 'Chave do Pensamento';
        }
    }

    onClickReset(){
        this.cancel();
    }

    onClickNext(){
        this.ok();
    }

    ok(){
        this.modalInstance.close(true);
    }

    cancel(){
        this.modalInstance.dismiss('cancel');
    }
}



// WEBPACK FOOTER //
// ./src/app/components/dialogs/feedback/feedback.controller.js